import styled from 'styled-components';
import { useConfigurationCardDenseNav } from './useConfigurationCardDenseNav.ts';

// Altezza della barra: combacia col min-height dell'header denso
const BAR_HEIGHT = 40;

/**
 * Contenitore sticky ad altezza ZERO: non riserva spazio nel flusso — la barra
 * compare e scompare senza spostare il contenuto.
 */
const StickyBar = styled.div`
  position: sticky;
  top: 0;
  height: 0;
  z-index: 20;
`;

/**
 * Barra col titolo della card nascosta.
 */
const TitleBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${BAR_HEIGHT}px;
  /* Include 3px di bordo laterale. */
  padding: 0 28px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid ${props => props.theme.colorBorder};
  /* Stesso sfondo degli header densi: la barra ne fa le veci in scroll. */
  background-color: ${props =>
    props.theme.Layout?.bodyBg ?? props.theme.colorBgLayout};
  color: ${props => props.theme.colorText};
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;
  /* Stacca la barra dal contenuto che le scorre sotto. */
  box-shadow: 0 1px 0 ${props => props.theme.colorSplit};
  box-shadow: ${props => props.theme.boxShadowTailwindMd};
`;

const TitleIcon = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 19px;
  color: ${props => props.theme.colorPrimary};
`;

const TitleText = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

/**
 * Barra di subentro per i `ConfigurationCardGroup` in modalità `dense`
 * (drawer di configurazione). Assente finché tutti i titoli sono visibili.
 *
 * È solo presentazione, non interattiva. Il tracking dello scroll vive in
 * `useConfigurationCardDenseNav`.
 */
export function ConfigurationCardDenseNav() {
  const { navRef, current, hasSections } = useConfigurationCardDenseNav();

  if (!hasSections) return null;

  return (
    <StickyBar ref={navRef}>
      {current != null && (
        <TitleBar aria-hidden="true">
          {current.icon != null && <TitleIcon>{current.icon}</TitleIcon>}
          <TitleText>{current.label ?? current.title}</TitleText>
        </TitleBar>
      )}
    </StickyBar>
  );
}
